import { gql } from "@apollo/client";

export const typeDef = gql`
  type SearchConfig {
    livePaletteKeywords: [String]
    keywordMinScore: [KeywordMinScore]
    defaultMinScore: Int
  }
  type KeywordMinScore {
    keyword: String
    score: Int
  }
  type Query {
    searchConfig: SearchConfig
  }
`;

export const resolvers = {
  Query: {
    searchConfig: async (_parent, _args, { dataSources }) => {
      const res = await dataSources.searchConfig.getSearchConfig();
      return {
        livePaletteKeywords: res.live_palette_keywords,
        keywordMinScore: res.keyword_min_score,
        defaultMinScore: res.default_min_score,
      };
    },
  },
};
